import { render, staticRenderFns } from "./SaveTokenFromSSOPage.vue?vue&type=template&id=39731835&"
import script from "./SaveTokenFromSSOPage.vue?vue&type=script&lang=js&"
export * from "./SaveTokenFromSSOPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports